

















































import BadConscienceDialog from "@/components/thg/BadConscienceDialog.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component, Ref, Vue } from "vue-property-decorator";
import { IThgImpact } from "./interface/ThgImpact.interface";
import { ReportModule } from "@/store/modules/report.store";

@Component({
  components: {
    LayoutReportStep,
    BadConscienceDialog
  }
})
export default class ThgImpactSelector extends Vue implements IReportStep {
  @Ref("badConscienceDialog")
  readonly badConscienceDialog!: BadConscienceDialog;

  public header: IReportHeaderData = {
    title: "report.thgImpactSelector.title",
    description: "report.thgImpactSelector.description"
  };

  public instruction: IReportInstructionData = {
    title: "report.thgImpactSelector.instructionTitle",
    text: "report.thgImpactSelector.instructionText",
    pictures: [AssetEnum.charging],
    example: AssetEnum.charging,
    display: true
  };

  get selected() {
    return ThgCreateModule.impactTypeId;
  }

  set selected(id) {
    ThgCreateModule.setImpactTypeId(id);
  }

  get company() {
    return ReportModule.partner.companyName;
  }

  get items() {
    return ThgCreateModule.activeImpactTypeItems;
  }

  get item() {
    return ThgCreateModule.impactTypeItem;
  }

  get isDone() {
    return true;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  updateImpactTypeId(item: IThgImpact) {
    ThgCreateModule.setImpactType(item.impactType);
    ThgCreateModule.setImpactFactor(item.baseImpactFactor);

    if (item.showDialog) {
      this.badConscienceDialog.openDialog();
    }
  }

  mounted() {
    ThgCreateModule.setActiveImpactTypeItems(ThgCreateModule.activeImpactTypes);
    if (this.$route.query.campaign) {
      ThgCreateModule.setCampaign((this.$route.query.campaign as string) || "");
    }
  }
}
